import * as __model from '../model';

export class discountInfo {
    saving?:number;
    discount?:number;
    cpm?:number;
  }